import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LandingPageHeaderComponent } from "./pages/layout/landing-page-header/landing-page-header.component";
import { CategoryListComponent } from "./pages/components/landing-pages/category-list/category-list.component";
import { SubscribeComponent } from "./pages/components/landing-pages/subscribe/subscribe.component";
import { ChannelsComponent } from "./pages/components/landing-pages/channels/channels.component";
// import { CategorySearchComponent } from './pages/components/landing-pages/category-search/category-search.component';
// import { GenreComponent } from './pages/components/landing-pages/genre/genre.component';
// import { LoginUserChannelComponent } from './pages/components/landing-pages/login-user-channel/login-user-channel.component';
import { AuthGuard } from "./core/guards/auth.guard";
// import { AboutUsComponent } from './pages/components/landing-pages/about-us/about-us.component';
import { PrivacyPolicyComponent } from "./pages/components/landing-pages/privacy-policy/privacy-policy.component";
import { TermsAndConditionsComponent } from "./pages/components/landing-pages/terms-and-conditions/terms-and-conditions.component";
import { ContactUsComponent } from "./pages/components/landing-pages/contact-us/contact-us.component";
// import { FAQComponent } from './pages/components/landing-pages/faq/faq.component';
import { SearchChannelsComponent } from "./pages/components/landing-pages/search-channels/search-channels.component";
// import { ConsumerSignupComponent } from './pages/components/landing-pages/consumer/consumer-signup/consumer-signup.component';
import { PaymentComponent } from "./pages/components/general/payment/payment.component";
import { UserInfoGuard } from "./core/guards/user-info.guard";
import { GeneralModule } from "./pages/components/general/general.module";
import { PageNotFoundComponent } from "./pages/components/landing-pages/consumer/page-not-found/page-not-found.component";
import { FanLandingPageComponent } from "./pages/components/landing-pages/fan-landing-page/fan-landing-page.component";
import { StreamHeaderComponent } from "./pages/layout/stream-header/stream-header.component";
import { LandingPageSliderComponent } from "./pages/components/landing-pages/landing-page-slider/landing-page-slider.component";
import { VodComponent } from "./pages/components/user/vod/vod.component";
import { CallBackComponent } from "./pages/components/call-back/call-back.component";
import { MobileCallbackComponent } from "./pages/components/mobile-callback/mobile-callback.component";
import { AuthorizeComponent } from "./pages/components/authorize/authorize.component";
import { PreRegisterComponent } from "./pages/components/landing-pages/pre-register/pre-register.component";
import { CanDeactivateGuard } from "./core/guards/can-deactivate-guard";
import { SubscribePaymentComponent } from "./pages/components/general/subscribe-payment/subscribe-payment.component";
// import { WebsiteViewComponent } from './pages/components/website/layout/website-view/website-view.component';
// import { HomeComponent } from './pages/components/website/pages/home/home.component';
// import { CreatorsComponent } from './pages/components/website/pages/creators/creators.component';
// import { FansComponent } from './pages/components/website/pages/fans/fans.component';
import { OrganizersComponent } from "./pages/components/website/pages/organizers/organizers.component";
import { CategoryComponent } from "./pages/components/website/pages/category/category.component";
import { EventTermsConditionsComponent } from "./pages/components/event-navigation/pages/event-terms-conditions/event-terms-conditions.component";
// import { EventStagesComponent } from './pages/components/event-registration/event-stages/event-stages.component';
import { NewLayoutComponent } from "./pages/components/website/layout/new-layout/new-layout.component";
import { RequestDemoComponent } from "./pages/components/landing-pages/consumer/request-demo/request-demo.component";
import { ClaimTicketComponent } from "./pages/components/landing-pages/consumer/claim-ticket/claim-ticket.component";
// import { WebsiteViewComponent } from './pages/components/website/layout/website-view/website-view.component';
// import { HomeComponent } from './pages/components/website/pages/home/home.component';
// import { CreatorsComponent } from './pages/components/website/pages/creators/creators.component';
// import { FansComponent } from './pages/components/website/pages/fans/fans.component';
// import { BrowseAllComponent } from './pages/components/website/pages/browse-all/browse-all.component';
// import { OrganizersComponent } from './pages/components/website/pages/organizers/organizers.component';
import { CookiePloicyComponent } from "./pages/components/landing-pages/cookie-ploicy/cookie-ploicy.component";
import { ForCreatorsComponent } from "./pages/components/website/pages/for-creators/for-creators.component";
// import { UpcomingEventsComponent } from './pages/components/website/pages/upcoming-events/upcoming-events.component';
import { HomeUpdatesComponent } from "./pages/components/website/pages/home-updates/home-updates.component";
import { ChannelWebpageGuard } from "./core/guards/channel-webpage.guard";
import { MerchandiseComponent } from "./pages/layout/merchandise/merchandise.component";
import { CommunitiesComponent } from "./pages/components/communities/communities.component";
import { HomeV4Component } from "./pages/components/website/static-website-v4/home-v4/home-v4.component";
import { PaymentTransactionsComponent } from "./pages/components/general/payment-transactions/payment-transactions.component";
import { SampleThemePageComponent } from "./sample-theme-page/sample-theme-page.component";
import { devPreviewGuard } from "./core/guards/dev-preview.guard";
import { environment } from "src/environments/environment";
//import { MobileAppDownloadComponent } from "./pages/components/landing-pages/consumer/mobile-app/mobile-app-download.component";

const routes: Routes = [
  {
    path: "",
    component: NewLayoutComponent,
    children: [
      // { path: "", component: ForCreatorsComponent, canActivate: [UserInfoGuard] },
      {
        path: "creators",
        component: ForCreatorsComponent,
        canActivate: [UserInfoGuard],
      },
      {
        path: "communities",
        component: CommunitiesComponent,
        canActivate: [UserInfoGuard],
      },
      // { path: "", component: HomeUpdatesComponent, canActivate: [UserInfoGuard] },
      { path: "", component: HomeV4Component, canActivate: [UserInfoGuard] },
      // { path: "becomeapartner", component: HomeComponent, canActivate: [UserInfoGuard] },
      {
        path: "privacypolicy",
        component: PrivacyPolicyComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "privacypolicy" },
      },
      {
        path: "termsandconditions",
        component: TermsAndConditionsComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "termsandconditions" },
      },
      {
        path: "cookiepolicy",
        component: CookiePloicyComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "cookieploicy" },
      },
      {
        path: "contactus",
        component: ContactUsComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "contactus" },
      },
      {
        path: "pre-register",
        component: PreRegisterComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "creator-pre_register" },
      },
      {
        path: "request-for-demo",
        component: RequestDemoComponent,
        canActivate: [UserInfoGuard],
        data: { heading: "creator-pre_register" },
      },
      { path: "sample-page", component: SampleThemePageComponent, canActivate: [devPreviewGuard] },
    ],
  },
  // header and footer is not provided
  // {
  //   path: "communities",
  //   component: CommunitiesComponent,
  //   canActivate: [UserInfoGuard],
  // },
  { path: '', loadChildren: () => import('./pages/components/website/website.module').then(m => m.WebsiteModule) },
  ...(environment.clientDetails?.required_crypto_wallet === 1
    ? [
        {
          path: 'nft-profile',
          loadChildren: () => import('./pages/components/nft/nft-profile/nft-profile.module').then(m => m.NftProfileModule)
        }
      ]
    : []),
  // {
  //   path: "",
  //   component: WebsiteViewComponent,
  //   children: [
  //     // { path: "", component: HomeComponent, canActivate: [UserInfoGuard] },

  //     // { path: "creators", component: CreatorsComponent, canActivate: [UserInfoGuard] },
  //     // { path: "fans", component: FansComponent, canActivate: [UserInfoGuard] },
  //     // { path: "browse", component: BrowseAllComponent, canActivate: [UserInfoGuard] },
  //     { path: "view/:category", component: CategoryComponent, canActivate: [UserInfoGuard] },
  //     { path: "organizers", component: OrganizersComponent, canActivate: [UserInfoGuard] },
  //     // { path: "aboutus", component: AboutUsComponent, canActivate: [UserInfoGuard], data: { heading: 'aboutus' } },
  //     // { path: "privacypolicy", component: PrivacyPolicyComponent, canActivate: [UserInfoGuard], data: { heading: 'privacypolicy' } },
  //     // { path: "termsandconditions", component: TermsAndConditionsComponent, canActivate: [UserInfoGuard], data: { heading: 'termsandconditions' } },
  //     // { path: "contactus", component: ContactUsComponent, canActivate: [UserInfoGuard], data: { heading: 'contactus' } },
  //     // { path: "privacypolicy", component: PrivacyPolicyComponent, canActivate: [UserInfoGuard], data: { heading: 'privacypolicy' } },
  //     { path: "termsandconditions", component: TermsAndConditionsComponent, canActivate: [UserInfoGuard], data: { heading: 'termsandconditions' } },
  //     { path: "cookiepolicy", component: CookiePloicyComponent, canActivate: [UserInfoGuard], data: { heading: 'cookieploicy' } },
  //     { path: "contactus", component: ContactUsComponent, canActivate: [UserInfoGuard], data: { heading: 'contactus' } },
  //     // { path: "signup", component: ConsumerSignupComponent, canActivate: [UserInfoGuard] },
  //     // { path: "faq", component: FAQComponent, canActivate: [UserInfoGuard], data: { heading: 'faq' } },
  //     { path: "fan-landing", component: LandingPageSliderComponent, canActivate: [UserInfoGuard] },
  //     // { path: "home/:categoryName/:subCategory", component: CategorySearchComponent, canActivate: [UserInfoGuard] },
  //     { path: "channels/:organizationId/:organizationName", component: ChannelsComponent, canActivate: [UserInfoGuard] },
  //     { path: "search", component: SearchChannelsComponent, canActivate: [UserInfoGuard] },
  //     // { path: "home/:categoryName/:subCategory/:genre", component: GenreComponent, canActivate: [UserInfoGuard] },
  //     { path: "subscribe", component: SubscribeComponent, canActivate: [UserInfoGuard] },
  //     // { path: "userhome", component: LoginUserChannelComponent, canActivate: [AuthGuard] },
  //     // { path: "mylist", component: LoginUserChannelComponent, canActivate: [AuthGuard] },
  //     // { path: "test-stream/:id", component: LivestreamTestComponent, canActivate: [UserInfoGuard] },
  //     { path: "channelpayment/:token", component: PaymentComponent, canActivate: [AuthGuard] },
  //     { path: "pre-register", component: PreRegisterComponent, canActivate: [UserInfoGuard], data: { heading: 'creator-pre_register' } },
  //     // { path: "claim-tickets/:ticket_key", component: ClaimTicketComponent, canActivate: [UserInfoGuard] },
  //   ]
  // },

  // {
  //   path: "",
  //   component: LandingPageHeaderComponent,
  //   children: [
  //     { path: "fan-landing", component: LandingPageSliderComponent, canActivate: [UserInfoGuard] },
  //     { path: "", component: CategoryListComponent, canActivate: [UserInfoGuard] },
  //     { path: "home/:categoryName/:subCategory", component: CategorySearchComponent, canActivate: [UserInfoGuard] },
  //     { path: "channels/:organizationId/:organizationName", component: ChannelsComponent, canActivate: [UserInfoGuard] },
  //     { path: "search", component: SearchChannelsComponent, canActivate: [UserInfoGuard] },
  //     { path: "home/:categoryName/:subCategory/:genre", component: GenreComponent, canActivate: [UserInfoGuard] },
  //     { path: "subscribe", component: SubscribeComponent, canActivate: [UserInfoGuard] },
  //     { path: "userhome", component: LoginUserChannelComponent, canActivate: [AuthGuard] },
  //     { path: "aboutus", component: AboutUsComponent, canActivate: [UserInfoGuard], data: { heading: 'aboutus' } },
  //     { path: "privacypolicy", component: PrivacyPolicyComponent, canActivate: [UserInfoGuard], data: { heading: 'privacypolicy' } },
  //     { path: "termsandconditions", component: TermsAndConditionsComponent, canActivate: [UserInfoGuard], data: { heading: 'termsandconditions' } },
  //     { path: "contactus", component: ContactUsComponent, canActivate: [UserInfoGuard], data: { heading: 'contactus' } },
  //     { path: "faq", component: FAQComponent, canActivate: [UserInfoGuard], data: { heading: 'faq' } },
  //     { path: "signup", component: ConsumerSignupComponent, canActivate: [UserInfoGuard] },
  //     { path: "channelpayment/:token", component: PaymentComponent, canActivate: [AuthGuard] },
  //     { path: "pre-register", component: PreRegisterComponent, canActivate: [UserInfoGuard], data: { heading: 'creator-pre_register' } },
  //   ]
  // },

  { path: "fan", component: FanLandingPageComponent },
  { path: "callback", component: CallBackComponent },
  { path: "mobile-callback", component: MobileCallbackComponent },
  { path: "authorize", component: AuthorizeComponent },
  { path: "subscribe-payment", component: SubscribePaymentComponent },
  // {
  //   path: "event", loadChildren: "./pages/components/event-registration/event-registration.module#EventRegistrationModule",
  //   canActivate: [UserInfoGuard]
  // },
  // {
  //   path: "event",
  //   loadChildren: () => import("./pages/components/event-navigation/event-navigation.module").then(m => m.EventNavigationModule),
  //   canActivate: [UserInfoGuard],

  // },
  {
    path: "eventterms",
    component: EventTermsConditionsComponent,
  },
   {
    path: "c",
    loadChildren: () => import("./pages/components/user/user.module").then(m => m.UserModule),
    canActivate: [AuthGuard],
  },
  {
    path: "user-dashboard",
    loadChildren: () => import("./pages/components/user-dashboard/user-dashboard.module").then(m => m.UserDashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: "network-market",
    loadChildren: () => import("./pages/components/merche-marketplace/merche-marketplace.module").then(m => m.MercheMarketplaceModule),
    canActivate: [UserInfoGuard],
  },
  {
  path: "merchandise",
  loadChildren: () => import("./pages/components/indigenous-cloud/indigenous-cloud.module").then(m => m.IndigenousCloudModule),
  canActivate: [UserInfoGuard],
  data: { source: 'network-merchandise' }
  },
  // {
  //   path: ":channelName/event",
  //   loadChildren: () =>
  //     import("./pages/components/event-navigation/event-navigation.module")
  //       .then(m => m.EventNavigationModule),
  //   canActivate: [UserInfoGuard],
  // },
  ...(environment.clientDetails?.required_crypto_wallet === 1
    ? [
        {
          path: "nft",
          loadChildren: () => import("./pages/components/nft/nft.module").then(m => m.NftModule),
          canActivate: [UserInfoGuard]
        }
      ]
    : []),
  {
    path: "page-not-found/404",
    component: PageNotFoundComponent,
    canActivate: [UserInfoGuard],
    pathMatch: "full",
  },
  { path: "payment/:token", component: PaymentComponent },
  { path: "product-payment/:token", component: MerchandiseComponent },
  {
    path: "vod-tip-donation-payment/:token",
    component: PaymentTransactionsComponent,
  },
  {
    path: "community-tip-donation-payment/:token",
    component: PaymentTransactionsComponent,
  },
  {
    path: "",
    loadChildren: () => import("./pages/components/streaming-module/streaming.module").then(m => m.StreamingModule),
  },
  {
    path: "",
    loadChildren: () => import("./pages/components/indigenous-cloud/indigenous-cloud.module").then(m => m.IndigenousCloudModule),
    canActivate: [ChannelWebpageGuard],
    canActivateChild: [ChannelWebpageGuard],
  },

  // {
  //   path: "", loadChildren: "./pages/components/organization-webpage/organization-webpage.module#OrganizationWebpageModule",
  //   canActivate: [UserInfoGuard]
  // },

  // {
  //   path: "",
  //   component: StreamHeaderComponent,
  //   children: [
  //     { path: "stream/:eventId", component: StreamingPageComponent, canDeactivate: [CanDeactivateGuard] },
  //     { path: "group-stream/:event_id", component: MultiStreamComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  //     { path: "watch/:eventId", component: VodComponent },
  //     { path: "screen-share/:streamName", component: ScreenShareComponent, canActivate: [AuthGuard] },
  //   ]
  // },
  // {path: "schedule/:id", component: EventStagesComponent},
  // {
  //   path: "mobile/404",
  //   component: MobileAppDownloadComponent,
  //   canActivate: [UserInfoGuard],
  // },
  {
    path: "**",
    component: PageNotFoundComponent,
    canActivate: [UserInfoGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { ...GeneralModule, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static COMPONENTS = [
    // LandingPageHeaderComponent,
    CategoryListComponent,
    // CategorySearchComponent,
    // GenreComponent,
    // LoginUserChannelComponent,
    // AboutUsComponent,
    // PrivacyPolicyComponent,
    // TermsAndConditionsComponent,
    // CookiePloicyComponent,
    // ContactUsComponent,
    // FAQComponent,
    // ConsumerSignupComponent
  ];
}
